// Inline SVG paths for the sidebar. Hand-rolled rather than an icon package:
// the shell needs a handful of glyphs, and a dependency for that is 40 kB of
// bundle for nine shapes.
//
// All 24x24, stroke-based, so they inherit currentColor.

export const ICONS = {
  home:     'M3 10.5 12 3l9 7.5M5 9.5V21h14V9.5',
  users:    'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75',
  shield:   'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z',
  building: 'M3 21h18M5 21V4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v17M15 9h3a1 1 0 0 1 1 1v11M9 7h2M9 11h2M9 15h2',
  bell:     'M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9M13.7 21a2 2 0 0 1-3.4 0',
  // An envelope, for the mail client.
  mail:     'M4 5h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2zM22 7l-10 7L2 7',
  activity: 'M22 12h-4l-3 9L9 3l-3 9H2',
  // Bars in a frame, for Informes. Deliberately not `forecast`, which S&OP
  // already uses and which draws a line over its bars: a reporting module
  // that shared a glyph with the planning module would be two entries in the
  // sidebar with the same picture, which is the exact failure this file's
  // test exists to prevent.
  chart:    'M3 3v18h18M7 16v-5M12 16V8M17 16v-9',
  user:     'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8',
  logout:   'M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9',
  sun:      'M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10zM12 1v2M12 21v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M1 12h2M21 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4',
  moon:     'M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z',
  // «El que diga el aparato»: la tercera opción del tema.
  monitor:  'M4 4h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zM8 20h8M12 16v4',
  menu:    'M3 6h18M3 12h18M3 18h18',
  // Apuntar algo que no estaba. La cruz sola y no una hoja con una cruz: en la
  // barra de campo de un teléfono se dibuja a 21px al lado de otras tres, y a
  // ese tamaño lo que se lee de una hoja con algo dentro es una mancha.
  plus:     'M12 5v14M5 12h14',
  box:      'M21 16V8l-9-5-9 5v8l9 5 9-5zM3.3 7.3 12 12l8.7-4.7M12 22V12',
  // Stacked shelves. Next to `box` in the sidebar it has to read as the place
  // things are kept rather than as another crate, so it is the layers glyph.
  layers:   'M12 2 2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5',
  search:   'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM21 21l-4.35-4.35',
  download: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3',
  refresh:  'M23 4v6h-6M1 20v-6h6M20.5 9A9 9 0 0 0 5.6 5.6L1 10M23 14l-4.6 4.4A9 9 0 0 1 3.5 15',
  sliders:  'M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3M1 14h6M9 8h6M17 16h6',
  clipboard:'M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2M9 2h6a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z',
  briefcase:'M20 7H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16',
  // Ticks against lines, for `tasks`. Deliberately not the clipboard, which is
  // already «Mi día»: two modules about work to be done, drawn the same, would
  // be two entries nobody can tell apart at a glance in the sidebar.
  checklist:'M9 6h12M9 12h12M9 18h12M3 6l1.5 1.5L7 5M3 12l1.5 1.5L7 11M3 18l1.5 1.5L7 17',
  plug:     'M9 2v6M15 2v6M6 8h12v4a6 6 0 0 1-12 0zM12 18v4',
  // A life ring: the handles are what make it read as help rather than a target.
  lifebuoy: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8M4.9 4.9l4.2 4.2M14.9 14.9l4.2 4.2M14.9 9.1l4.2-4.2M9.1 14.9l-4.2 4.2',
  // Points down when its section is open; rotated by CSS when it is closed.
  chevron:  'M6 9l6 6 6-6',

  // ── What the modules ask for ───────────────────────────────────────────────
  //
  // A name with no shape behind it does not fail: `iconPath` falls back to the
  // crate, silently. Three modules were asking for `file`, `hammer` and
  // `wrench`, so Presupuestos, Proyectos and Órdenes all drew the same crate as
  // Taller and Compras — five identical glyphs down one sidebar, and nothing
  // anywhere to say so. There is a test for it now; see navIcons.test.js.
  file:     'M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5zM14 3v5h5M9 13h6M9 17h4',
  // A hanging folder with a tab, drawn NEXT to `file` on purpose: the two sit
  // one row apart in the sidebar (Presupuestos and Documentos), so the sheet of
  // paper and the drawer it lives in have to be tellable apart at 18px. The tab
  // is what does it — a plain rectangle reads as a card at that size.
  folder:   'M3 7a2 2 0 0 1 2-2h4l2 2.5h8a2 2 0 0 1 2 2V18a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z',
  // A card with a person on it. The customers are people; the briefcase this
  // replaces read as 'business' in general, which is the whole sidebar.
  contact:  'M4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zM9.5 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4M6.5 16a3.5 3.5 0 0 1 6 0M15 10h3M15 13.5h2.5',
  // A receipt: the torn bottom edge is the whole point. Next to `file` in the
  // sidebar a plain sheet of paper would read as another document, and the two
  // rows would share one picture — which is what the icon is there to prevent.
  receipt:  'M6 3h12a1 1 0 0 1 1 1v17l-3-2-3 2-3-2-3 2V4a1 1 0 0 1 1-1zM9 8h6M9 12h6M9 16h3',
  factory:  'M3 21h18M5 21V11l5 3V11l5 3V11l4 2.5V21M9.5 21v-4h3v4',
  // Una grúa torre, para Obras. Deliberadamente NO es `building`, que es la
  // ficha de la empresa, ni `factory`, que es el taller: las tres hablan de
  // construcción y lo que las separa en la barra es la silueta. Esta es la
  // única con una horizontal en alto y algo colgando de ella.
  crane:    'M4 21h6M7 21V4M7 4h13M20 4v3M7 7l6-3M13 20v-6M11 16h4',
  // A node with two children. The asset census sits next to `factory`
  // (Producción) and `gauge` (Mantenimiento) in the sidebar, and what tells it
  // apart from both is not what it is about — the three are about the plant —
  // but its shape: it is the only one of the three that is a tree.
  tree:     'M9 3h6v4H9zM3 17h6v4H3zM15 17h6v4h-6zM12 7v6M6 13h12M6 13v4M18 13v4',
  // A map pin. The sites row sits under `building` (the company) in the
  // platform group, and what separates them is the question each answers:
  // `building` is who the company is, this one is where it is — several times.
  sites:    'M12 21s7-5.6 7-11a7 7 0 1 0-14 0c0 5.4 7 11 7 11zM12 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5',
  // A folded map, and it is deliberately NOT the pin above it. `sites` is one
  // place, ours, and it belongs to the company's own file; this row is the
  // customer's places — plural, worked as rounds — so what it draws is the
  // territory rather than a point on it. The two would otherwise be the same
  // picture next to two different rows, which is the thing this file has a test
  // about.
  estate:   'M3 6l6-3 6 3 6-3v15l-6 3-6-3-6 3zM9 3v15M15 6v15',
  cart:     'M2 3h2.2l2.6 12.4a1.6 1.6 0 0 0 1.6 1.3h8.9a1.6 1.6 0 0 0 1.6-1.3L21 7H5.4M9.6 21.2a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4M17 21.2a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4',
  // Bars against a time axis: phases and how far each one got, which is what
  // the projects screen is. A hammer says 'work' and every module is work.
  gantt:    'M4 3v18M8 6.5h9M8 12h6M8 17.5h11',
  // A line climbing over its axis, with the months underneath it. It sits two
  // rows from `gantt` and one from `activity`, and what tells the three apart is
  // the question each asks: gantt is bars along time (what is running), activity
  // is a spike (what just happened), this is a curve going forward — the months
  // that have not happened yet, which is the whole of S&OP.
  forecast: 'M3 3v18h18M7 21V9M12 21V5M17 21v-8M6 12l5-5 5 4 4-6',
  wrench:   'M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.6-3.6a6 6 0 0 1-7.9 7.9l-6.8 6.8a2.1 2.1 0 0 1-3-3l6.8-6.8a6 6 0 0 1 7.9-7.9l-3.6 3.6z',
  // A dial with its needle past the middle. Maintenance is half meters — every
  // 15 000 km, every 500 hours — and a cog would read as settings, which is
  // what `sliders` already is two rows further down.
  gauge:    'M12 21a9 9 0 1 1 9-9M12 21a9 9 0 0 0 9-9M3 12h2M19 12h2M5.6 5.6l1.4 1.4M12 3v2M12 12l5-3.5',
  // Clocking in is a clock. The clipboard it replaces was one of three.
  clock:    'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 7.5V12l3 1.8',
  calendar: 'M7 3v3M17 3v3M4 6h16a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zM3 10.5h18',
  // The platform's own agenda: the same sheet with one appointment on it, so it
  // does not read as attendance's calendar two rows above.
  agenda:   'M7 3v3M17 3v3M4 6h16a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zM3 10.5h18M7.5 14h4v3.5h-4z',
  list:     'M8.5 6H21M8.5 12H21M8.5 18H21M3.5 6h1.5M3.5 12h1.5M3.5 18h1.5',
  // A globe with its meridians. The website module is the only one whose
  // subject is outside the company, and a screen or a cursor would read as
  // «the computer» rather than «our site out there».
  globe:    'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM3.5 9h17M3.5 15h17M12 3a14 14 0 0 0 0 18M12 3a14 14 0 0 1 0 18',
  // A delivery van. The fleet needs the vehicle itself, not another crate.
  van:      'M2 6h11v9H2zM13 9h4l3 3.5V15h-7zM6.5 19.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4M17 19.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4',
  // What you are holding when you have taken a van. «Mi vehículo» is not the
  // fleet seen small: it is the key that is in your pocket.
  key:      'M21 3l-8.6 8.6a5.5 5.5 0 1 0 3 3L18 11l2.2 2.2 1.4-1.4-2.2-2.2 1.6-1.6zM7.5 18.6a1.7 1.7 0 1 0 0-3.4 1.7 1.7 0 0 0 0 3.4',
  // Three people tied together, not a crowd. `users` was already the staff
  // directory of the platform, and a crew is a different idea from "everybody
  // who has an account": what this draws is the tie between them, which is the
  // whole point of the module that asks for it.
  crew:     'M12 3.2a2.6 2.6 0 1 0 0 5.2 2.6 2.6 0 0 0 0-5.2M5.4 15.2a2.6 2.6 0 1 0 0 5.2 2.6 2.6 0 0 0 0-5.2M18.6 15.2a2.6 2.6 0 1 0 0 5.2 2.6 2.6 0 0 0 0-5.2M10.3 7.6 7.1 14M13.7 7.6l3.2 6.4M8 17.8h8',
  // A card with somebody on it: the pass that says who you are and what you may
  // do. `users` is the platform's own account directory and `crew` is a team;
  // an employee FILE is neither — it is the papers a person carries, so what
  // this draws is the card and not the people.
  badge:    'M4 4h16a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zM9 10.4a1.9 1.9 0 1 0 0-3.8 1.9 1.9 0 0 0 0 3.8M5.6 16.4a3.4 3.4 0 0 1 6.8 0M14.5 8.5h4M14.5 12h4M14.5 15.5h2',
  // Two rings and a sweep out to a blip. `activity` is already a spike — what
  // just happened — and `globe` is the world; this is the act of WATCHING, which
  // is what the market module does: rings of distance and one thing on them
  // worth looking at.
  radar:     'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 16.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9M12 12l6.4-6.4M17.5 7.5a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4',
  // A warning triangle, for Incidencias. It is the one glyph in this file that
  // does not describe its subject but its URGENCY, and that is deliberate: the
  // row is not about machines or about sites — it is about the fact that
  // something is wrong with one of them. `gauge` (Mantenimiento) and `tree` (el
  // censo) are two rows away and both are about the plant; what tells this one
  // apart at 18px is that it is the only shape in the sidebar with a point at
  // the top. The stroke stops short of the corner on purpose — a filled
  // triangle reads as an error banner rather than as a section.
  alert:     'M10.6 4.1 2.3 18.4a1.6 1.6 0 0 0 1.4 2.4h16.6a1.6 1.6 0 0 0 1.4-2.4L13.4 4.1a1.6 1.6 0 0 0-2.8 0zM12 9.6v4.6M12 17.3v.1',
  // A door with a handle, for the one module whose subject is somebody coming
  // in from outside. `building` was the obvious candidate and is taken by the
  // company's own file, which is the opposite thing: this row is about the
  // people who are NOT in the building.
  door:      'M4 21h16M6 21V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v17M14 12h1.5',
  // A walkie-talkie: the body, its antenna and the grille. Radio is the
  // company's own channel between the office and the field, and the handheld
  // radio of a building site is exactly what it replaces. `mail` and `bell` are
  // taken by the other two ways the ERP reaches somebody, and neither has an
  // antenna.
  radio:     'M9 7h6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2zM14 7V2M10 11h4M10 14h4M10 17h4',
  // A video camera: the body and its lens cone. Radio's meetings, the one row
  // about sitting down with someone — inside or outside the company — on video.
  video:     'M4 7h10a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zM15 10.5l5-3v9l-5-3',
  // Apple's Share button, drawn the way Safari draws it: the guide to installing
  // on an iPad says «tap this», and only works if this is what the person sees.
  share:     'M8 9H6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1h-2M12 15V3M8 6.5 12 3l4 3.5',
  // «Add to Home Screen» in that same menu: a plus in a rounded square.
  'add-app': 'M6 3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zM12 8v8M8 12h8',
}

export const iconPath = (name) => ICONS[name] ?? ICONS.box
